import { useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import Modal from "react-modal";
Modal.setAppElement("#root");

const InsuranceCardUpdate = () => {
  const accessToken = localStorage.getItem("accessToken");
  const { id } = useParams();
  const location = useLocation();
  const insuranceDataToUpdate = location.state?.insuranceDataToUpdate;
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const navigate = useNavigate();

  const handleCloseModal = () => {
    setShowSuccessModal(false);
    navigate(`/employeedirectory/${id}`);
  };

  const insuranceDocuments = insuranceDataToUpdate.documents.filter(
    (doc) => doc.name === "Insurance Card"
  );
  const insuranceDetailsArray = insuranceDocuments.map((doc) => ({
    id: doc.id,
    name: doc.name,
    number: doc.number,
    url: doc.url,
    expiryDate: doc.expiryDate,
  }));

  const [documentState, setDocumentState] = useState({
    name: insuranceDetailsArray[0]?.name || "",
    id: insuranceDetailsArray[0]?.id || "",
    number: insuranceDetailsArray[0]?.number || "",
    url: insuranceDetailsArray[0]?.url || "",
    expiryDate: insuranceDetailsArray[0]?.expiryDate || "",
  });

  const handleInputChange = (e) => {
    // Update the state with the new value as you type
    const { name, value } = e.target;
    setDocumentState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleUpdateDocument = () => {
    const apiUrl = `${process.env.REACT_APP_BASE_URL}/employees/documents/update`;

    // Check if a new file has been selected
    const fileInput = document.querySelector('input[type="file"]');
    const newFile = fileInput.files[0];

    // Create a FormData object
    const formData = new FormData();

    // Append the existing document URL if it exists
    if (!newFile && documentState.url) {
      formData.append("documents[0][document_url]", documentState.url);
    }

    // Append the new file if it exists
    if (newFile) {
      formData.append("documents[0][file]", newFile, newFile.name);
    }

    // Add other data to the FormData
    formData.append("id", id);
    formData.append("documents[0][id]", documentState.id);
    formData.append("documents[0][name]", documentState.name);
    formData.append("documents[0][expiry_date]", documentState.expiryDate);
    formData.append("documents[0][document_number]", documentState.number);

    // Define headers
    const headers = {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
    };

    // Make the API request using Axios
    axios
      .post(apiUrl, formData, { headers })
      .then((response) => {
        setShowSuccessModal(true);
      })
      .catch((error) => console.error("Error:", error));
  };

  return (
    <div className="board__layout">
      <div className="section-header">
        <h1>Update Insurance Card</h1>
      </div>

      <div className="form-item">
        <div className="form-rows">
          {/* <div>
            <label htmlFor="name">Document Name</label>
            <input
              type="text"
              name="name"
              placeholder="Document Name"
              disabled
              value={documentState.name}
              onChange={(e) =>
                setDocumentState({ ...documentState, name: e.target.value })
              }
            />
          </div> */}
          <div>
            <label htmlFor="file">Upload Insurance Card</label>
            <input name="file" className="custom-file-upload" type="file" />
          </div>

          <div className="form-rows">
            <div>
              <label htmlFor="document_number">Document Number</label>
              <input
                type="text"
                name="document_number"
                placeholder="Document Number"
                value={documentState.number}
                onChange={(e) =>
                  setDocumentState({ ...documentState, number: e.target.value })
                }
              />
            </div>
          </div>

          <div className="form-rows">
            <div>
              <label htmlFor="expiry_date">Expiry Date</label>
              <input
                type="date"
                name="expiry_date"
                placeholder="Expiry Date"
                value={documentState.expiryDate}
                onChange={(e) =>
                  setDocumentState({
                    ...documentState,
                    expiryDate: e.target.value,
                  })
                }
              />
            </div>
          </div>

          <div style={{ display: "none" }}>
            <label htmlFor="employee_info_id">Employee Information ID</label>
            <input
              type="number"
              name="employee_info_id"
              id="employee_info_id"
            />
            <label htmlFor="document_id">Document ID</label>
            <input
              type="number"
              name="document_id"
              id="document_id"
              value={documentState.id}
              onChange={(e) =>
                setDocumentState({ ...documentState, id: e.target.value })
              }
            />
          </div>
        </div>
      </div>

      <div className="form-btn-div" style={{ marginTop: "1rem" }}>
        <button
          type="button"
          className="btn-skip"
          onClick={() => navigate(`/dashboard`)}
        >
          Close
        </button>
        <button onClick={handleUpdateDocument} className="form-btn-submit">
          Update
        </button>
      </div>

      <Modal
        isOpen={showSuccessModal}
        onRequestClose={() => setShowSuccessModal(false)}
        contentLabel="Data Updated Successfully"
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
      >
        <h5>Details Updated Successfully</h5>
        <button onClick={handleCloseModal}>OK</button>
      </Modal>
    </div>
  );
};

export default InsuranceCardUpdate;
